import type { TEmailBuilderEditingMode, TEmailBuilderActivePanel } from "redux/reducers/emailBuilder/emailBuilder";

export function emailBuilderShouldCloseBlockSettingsForToolbarPanel(
  panel: TEmailBuilderActivePanel,
  editingMode: TEmailBuilderEditingMode,
): boolean {
  return panel !== "none" && editingMode === "block-settings";
}

export function emailBuilderShouldCloseToolbarPanelForBlockSettings(
  activePanel: TEmailBuilderActivePanel,
  mutuallyExcludePanels: boolean,
): boolean {
  if (activePanel === "none") {
    return false;
  }

  if (mutuallyExcludePanels) {
    return true;
  }

  return activePanel !== "add-elements";
}
